import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import languages from "../../config/languages";
import HelpAdornment from "./HelpAdornment";

const baseOptions = Object.keys(languages).map(key => ({
    value: key,
    label: languages[key]
}));

function LanguageSelect({
    value, 
    onChange,
    size = "small",
    label = "Language", 
    helpKey,
    error = false,
    disabled = false, 
    required = false, 
    placeholder = "Select language...",
    hideHelpAdornment = false,
    showUndefined = false,
    showDontChange = false,
    showAnyOption = false   // <-- toggle to include the "Any" option
}) {
    let _options = [...baseOptions];

    if (showUndefined) {
        _options.unshift({ value: 'UND', label: 'Undefined' });
    }
    if (showDontChange) {
        _options.unshift({ value: '', label: "Don't change" });
    }
    if (showAnyOption && !required) {
        _options.unshift({ value: '', label: 'Any' });
    }

    const selectedOption = _options.find(o => o.value === value) || null;

    return (
        <Autocomplete
            options={_options}
            getOptionLabel={(option) => option.label}
            value={selectedOption}
            onChange={(e, newValue) => onChange(newValue ? newValue.value : '')}
            disabled={disabled}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    label={label} 
                    required={required}
                    error={error}
                    placeholder={placeholder}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: hideHelpAdornment ? null : <HelpAdornment helpKey={helpKey || "language"} />
                    }}
                />
            )}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            size={size}
        />
    );
}

export default LanguageSelect;
